import {IEmojiReactionData, IReactionGroup} from '../../model/emojiReactionsModel';

const groupRangeLengthSeconds = 0;

const createReactionGroup = (reaction: IEmojiReactionData, groupRangeInSeconds: number): IReactionGroup => (
   {
      startTime: reaction.Time,
      endTime: reaction.Time + groupRangeInSeconds,
      reactions: [reaction]
   } as IReactionGroup);

const getReactionGroupAtTime = (groupedReactions: IReactionGroup[], time: number) => {
   if (groupRangeLengthSeconds === 0) {
      return groupedReactions.find(reactionGroup => time >= reactionGroup.startTime && time <= reactionGroup.endTime);
   }
   return groupedReactions.find(reactionGroup => time >= reactionGroup.startTime && time < reactionGroup.endTime);
};

const groupReactionsByTime = (reactions: IEmojiReactionData[]): IReactionGroup[] => {
   const groupedReactions: IReactionGroup[] = [];
   reactions.forEach(reaction => {
      const existingGroup = getReactionGroupAtTime(groupedReactions, reaction.Time);
      if (existingGroup) {
         existingGroup.reactions.push(reaction);
      } else {
         groupedReactions.push(createReactionGroup(reaction, groupRangeLengthSeconds));
      }
   });
   return groupedReactions;
};

const getReactionGroups = (reactions: IEmojiReactionData[]): IReactionGroup[] => groupReactionsByTime(reactions);

export {getReactionGroups};
